import { useState, useEffect } from 'react';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import NewsPage from './pages/NewsPage';
import TrainingsPage from './pages/TrainingsPage';
import ExhibitionsPage from './pages/ExhibitionsPage';
import ProjectsPage from './pages/ProjectsPage';
import ContactPage from './pages/ContactPage';
import AdminPage from './pages/AdminPage';
import CatalogPage from './pages/CatalogPage';
import LoansPage from './pages/LoansPage';
import RegisterPage from './pages/RegisterPage';
import GdprPage from './pages/GdprPage';

function AppInner() {
  const { user, loading } = useAuth();
  const [page, setPage] = useState('news');
  const [showRegister, setShowRegister] = useState(false);

  useEffect(() => {
    const handler = (e) => setPage(e.detail);
    window.addEventListener('navigate', handler);
    return () => window.removeEventListener('navigate', handler);
  }, []);

  // Check for reset token in URL
  const params = new URLSearchParams(window.location.search);
  const resetToken = params.get('token');
  if (resetToken) {
    return <ResetPasswordPage token={resetToken} onBack={() => { window.history.replaceState({}, '', '/'); }} />;
  }

  // GDPR page accessible without login
  if (window.location.pathname === '/gdpr') {
    return <GdprPage onClose={() => window.history.back()} />;
  }

  if (loading) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Outfit','Segoe UI',sans-serif", color: '#9ca3af', fontSize: 16 }}>
      Načítání...
    </div>
  );

  if (!user) {
    if (showRegister) return <RegisterPage onBack={() => setShowRegister(false)} />;
    return <LoginPage onRegister={() => setShowRegister(true)} />;
  }

  const renderPage = () => {
    switch (page) {
      case 'news': return <NewsPage />;
      case 'trainings': return <TrainingsPage />;
      case 'exhibitions': return <ExhibitionsPage />;
      case 'projects': return <ProjectsPage />;
      case 'catalog': return <CatalogPage />;
      case 'loans': return <LoansPage />;
      case 'contact': return <ContactPage />;
      case 'admin': return user.role === 'admin' ? <AdminPage /> : <NewsPage />;
      default: return <NewsPage />;
    }
  };

  return (
    <Layout page={page} setPage={setPage}>
      {renderPage()}
    </Layout>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppInner />
    </AuthProvider>
  );
}
